import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=07c15494&"
import script from "./Index.vue?vue&type=script&setup=true&lang=ts&"
export * from "./Index.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports